import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { settings } from "./settings";
import { CAROUSEL_IMAGES } from "../../assets/data/dummyData";

const Carousel = () => {
	return (
		<Slider {...settings}>
			{CAROUSEL_IMAGES.map((item) => (
				<div key={item.id}>
					<img src={item.image} alt="Work Place" className="w-full h-auto" />
				</div>))
			}
		</Slider>
	);
};

export default Carousel;